__turbopack_context__.v({
  "buttonsWrapper": "yPq8SW_buttonsWrapper",
  "loaderWrapper": "yPq8SW_loaderWrapper",
});
